<template>
  <div class="section-title-wrap">
    <div class="section-title">
      <img :src="titleImage" />
      <div class="text">
        <div class="title">{{ title }}</div>
        <div class="content">{{ sub }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SectionTitle",
  props: ["title", "sub"],
  computed: {
    titleImage() {
      return require("../../assets/images/common/title.png");
    },
  },
};
</script>
<style lang="less" scoped>
.section-title-wrap {
  &.reverse .section-title {
    margin-bottom: -4%;
    margin-top: 0;
  }
  .section-title {
    color: #fff;
    width: 100%;
    height: auto;
    margin-top: -20%;
    text-align: center;
    position: relative;
    line-height: 0;

    img {
      max-width: 100%;
    }
    .text {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      line-height: normal;
      .title {
        font-size: 0.5em;
        text-shadow: 4px 4px 2px #e3812d;
        letter-spacing: 4.5px;
        font-weight: 600;
      }
      .content {
        font-size: 0.3em;
        letter-spacing: 2.88px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/items/sectionTitle.vue